import { useRef } from 'react';
import { Outlet, useLocation } from 'react-router';
import { usePullToRefreshSurface } from '@/pwa/PullToRefreshProvider';
import { MiniappTabBar } from '@/shared/components/ui/MiniappTabBar';

/** Routes where the tab bar should be hidden */
const TAB_BAR_HIDDEN_PATTERNS = [/^\/auth$/, /^\/clubs\//, /^\/reader\//, /^\/paywall\//];

export function TabBarLayout() {
  const { pathname } = useLocation();
  const scrollSurfaceRef = useRef<HTMLElement>(null);
  const isTabBarHidden = TAB_BAR_HIDDEN_PATTERNS.some((pattern) => pattern.test(pathname));

  usePullToRefreshSurface('tab-shell', scrollSurfaceRef);

  return (
    <div
      className="relative flex min-h-0 flex-none flex-col"
      style={{ height: 'var(--app-height, 100dvh)' }}
    >
      <main
        ref={scrollSurfaceRef}
        data-pull-to-refresh-surface="tab-shell"
        className="min-h-0 flex-1 overflow-y-auto overscroll-none"
      >
        <Outlet />
      </main>

      {!isTabBarHidden && <MiniappTabBar />}
    </div>
  );
}
